import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-choose-subproduct-admin-config',
  templateUrl: './choose-subproduct-admin-config.component.html',
  styleUrls: ['./choose-subproduct-admin-config.component.scss']
})
export class AtwChooseSubproductAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() data_tool: any
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  dataAfterChange: any = {};
  id_project: any;
  tabs = ['kieu_1', 'kieu_2', 'kieu_3'];
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  fonts = [];

  styles_field = [
    {
      title: 'dieu_chinh_vien_kieu_1',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_kieu_2',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_kieu_3',
      index: 3,
    },
  ];
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private http: HttpClient,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([fonts]: any) => {
      this.fonts = fonts;
    })

    this.class['-units__items--img'] ??= {
      'object-fit': 'contain', width: '40px', height: '40px',
    };
  }

  /**Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
  };
  /** Chọn kiểu units
   * @param index : Xác định kiểu unit
   * Ví dụ: kiểu 1 hoặc kiểu 2
   */
  chooseUnits(index) {
    if (index == 0) {
      this.config.units_type = 0;
    }
    else if (index == 1) {
      this.config.units_type = 1;
    }
    else {
      this.config.units_type = 2;
    }
    this.updateObject()
  }

  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  //   // this.cdRef.detectChanges()
  // }


  // cập nhật border right khi border top thay đổi màu
  updateBorderColor() {
    const color = this.class['+units-check__items--before']['border-top-color'];
    this.class['+units-check__items--before']['border-right-color'] = color;
  }

  
  /**
 * Hàm này dùng để mở rộng phần cấu hình.
 * @param field_text : trả về phần tử được chọn của mảng style_field
 */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm update class[operator + 'units__items--img'] và gán giá trị tương ứng
   * @param event Giá trị khi dùng $event trong html template
   * @param field Field của class cần update giá trị
   * @param unit Đơn vị đi kèm với giá trị, ví dụ: 'px', hoặc để trống ''
   * @param isUpdate Có cần update dữ liệu lên db không
   */
  updateImgSub(event, field, unit = '', isUpdate = true) {
    const operator = this.objectChoosing.isActive ? '+' : '-';
    this.class[operator + 'units__items--img'] ??= {
      'object-fit': 'contain', width: '40px', height: '40px',
    };
    this.class[operator + 'units__items--img'][field] = event + unit;
    if (isUpdate) {
      this.updateObject();
    }
  }
}
